import * as React from "react"
import { Select, Stack } from "@chakra-ui/react"

import { categories, eventTypes, regionsIncNed } from "lib/static/filters"

export interface EventFilters {
  type: string
  region: string
  category: string
}
interface EventsFilterbarProps {
  filters: EventFilters
  onSetFilters: (filters: EventFilters) => void
}

export const EventsFilterbar: React.FC<EventsFilterbarProps> = (props) => {
  const eventFilters = props.filters

  const setEventFilters = ({ filter, value }: { filter: keyof EventFilters; value: string }) => {
    props.onSetFilters({ ...eventFilters, [filter]: value })
  }

  return (
    <Stack spacing={4} direction={{ base: "column", lg: "row" }}>
      <Select
        placeholder="Alle typen"
        value={eventFilters.type}
        onChange={({ target: { value } }) => setEventFilters({ filter: "type", value })}
        aria-label="Selecteer type"
      >
        {eventTypes.map((eventType) => (
          <option key={eventType} value={eventType}>
            {eventType}
          </option>
        ))}
      </Select>
      <Select
        placeholder="Alle regio's"
        value={eventFilters.region}
        onChange={({ target: { value } }) => setEventFilters({ filter: "region", value })}
        aria-label="Selecteer regio"
      >
        {regionsIncNed.map((region) => (
          <option key={region} value={region}>
            {region}
          </option>
        ))}
      </Select>
      <Select
        placeholder="Alle categorieën"
        value={eventFilters.category}
        onChange={({ target: { value } }) => setEventFilters({ filter: "category", value })}
        aria-label="Selecteer categorie"
      >
        {categories.map((category, i) => (
          <option key={i} value={category}>
            {category}
          </option>
        ))}
      </Select>
    </Stack>
  )
}
